export default __webpack_public_path__ + "static/media/Sorting_07.d90e8280.png";